<form [formGroup]="filePicker" class="grid gap-6 mb-5">
  <div>
    <div class="mb-5">
      <h4 i18n="@@file-select-header-saf-t">Select file</h4>
      <p i18n="@@file-select-helper-text-saf-t">Choose a SAF-T file with a header</p>
    </div>
    <div class="d-flex align-items-start">
      <xena-input class="input-filename-text" value={{filename}} tabindex="-1" readonly>
        <span slot="error-text" *ngIf="filePicker.get('selectedFile').value?.name.length>0 && validation == false"
          i18n="@@file-error-no-header">The header in the file is not valid</span>
      </xena-input>
      <label>
        <xena-button class="input-filename-button" (click)="fileInput.click()" i18n="@@file-select-import-saf-t">
          Import SAF-T files</xena-button>
        <input #fileInput type="file" accept=".xml" (change)="onFileSelected($event)">
      </label>
    </div>
  </div>
</form>
